import React from 'react'
import TODO from './TODO'
import INPROGRESS from './INPROGRESS'
import DONE from './DONE'


const Calendar = () => {
  return (
    <div>
      <div className='lg:ml-72 mt-2'>
      <ol class="flex items-center whitespace-nowrap" aria-label="Breadcrumb">
          <li class="inline-flex items-center">
            <a class="flex items-center text-sm text-gray-500 hover:text-blue-600 focus:outline-none focus:text-blue-600 dark:focus:text-blue-500" href="#">
              Home
            </a>
            <svg class="flex-shrink-0 mx-2 overflow-visible size-4 text-gray-400 dark:text-neutral-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
          </li>
          
          <li class="inline-flex items-center text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
            Calendar
          </li>
        </ol>
      </div>
      <h2 className='font-bold text-black text-4xl lg:ml-72 mt-3'>All tasks</h2>
      <div className='grid grid-cols-3 gap-2 lg:ml-72 p-10'>
          
        <div className='bg-gray-100 rounded-lg '>
        <h3 className='m-3 font-medium text-gray-400'>TO DO</h3>
          <TODO name="RA" isTaske={true}/>
          <TODO name="SL"/>
          <TODO name="MO"/>
          
          
        </div>

        <div className='bg-gray-100 rounded-lg'>
        <h3 className='m-3 font-medium text-gray-400'>IN PROGRESS</h3>
            <INPROGRESS isTaske={true}/>
            <INPROGRESS/>
        </div>

        <div className='bg-gray-100 rounded-lg'>
        <h3 className='m-3 font-medium text-gray-400'>DONE</h3>
            <DONE/>
            <DONE/>
            <DONE/>
        </div>
      </div>
    </div>
  )
}

export default Calendar